import { BaseEntityListItemValidator } from './BaseEntityListItemValidator';
import { EntityListProductInputData } from '../entityListTypes';
import { ImportedItemValidatorContext } from '../../../../../lib/imports/importTypes';

export class EntityListProductItemValidator extends BaseEntityListItemValidator<EntityListProductInputData> {
  validate(
    item: Partial<EntityListProductInputData>,
    context?: ImportedItemValidatorContext[],
  ): string[] {
    return this.checkProduct(item, context);
  }

  protected checkProduct = (
    item: Partial<EntityListProductInputData>,
    context?: ImportedItemValidatorContext[],
  ): string[] => {
    const errors: string[] = [];

    if (!this.hasNonEmptyProperty(item, 'product')) {
      errors.push('Product cannot be empty');
    } else {
      const productContext = context?.find(c => c.id === 'product');
      if (productContext) {
        const pattern = productContext.pattern;
        const product = item.product;
        if (product) {
          if (!pattern.test(product)) {
            errors.push(productContext.errorMessage);
          }
        }
      }
    }

    return errors;
  };
}
